import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mongo-view" }
const _hoisted_2 = {
  key: 0,
  class: "data"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Tabs = _resolveComponent("Tabs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.collections === undefined)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode($setup["Listbox"], {
            modelValue: $data.selection,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.selection) = $event)),
            options: $data.collections,
            "option-label": "name",
            "option-value": "name",
            class: "list",
            unstyled: false
          }, null, 8 /* PROPS */, ["modelValue", "options"]),
          ($data.selection)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_Tabs, {
                  modelValue: $data.active,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.active) = $event)),
                  class: "tabs",
                  tabs: $data.tabs
                }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
                ($data.active==='documents')
                  ? (_openBlock(), _createBlock($setup["MgDocs"], {
                      key: 0,
                      coll_name: $data.selection
                    }, null, 8 /* PROPS */, ["coll_name"]))
                  : _createCommentVNode("v-if", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, "Select collection"))
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}